import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import { logoutService } from "../../../../services/authService";
import { useTranslation } from "react-i18next";
import { deleteTokenFCM } from "../../../../hooks/useFCM";
import { useAbility } from "@casl/react";
import { AbilityContext } from "../../../../config/abilityContext";

const UserDropdown = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const ability = useAbility(AbilityContext);

  const handleLogout = async () => {
    // delete fcm token
    // await deleteTokenFCM(); // ✅ Wait for clean removal
    await logoutService(navigate);
  };
  const { t } = useTranslation();
  return (
    <div className="dropdown ms-1">
      {/* User Icon as Dropdown Toggle */}
      <Link to="#" className="btn btn-outline-light bg-white btn-icon me-1" data-bs-toggle="dropdown">
        <i className="ti ti-user" /> {/* Profile Icon Instead of Image */}
      </Link>

      {/* Dropdown Menu */}
      <div className="dropdown-menu dropdown-menu-end">
        {/* Logout Option */}
        <Link className="dropdown-item d-inline-flex align-items-center p-2" to={routes.profile}>
          <i className="ti ti-user me-2" /> {t('profile')}
        </Link>
        {ability.can("read", "SettingsInstance") && (
          <Link className="dropdown-item d-inline-flex align-items-center p-2" to={routes.instanceSettings}>
            <i className="ti ti-settings me-2" /> {t('settings')}
          </Link>
        )}
        <Link className="dropdown-item d-inline-flex align-items-center p-2" to={routes.login} onClick={handleLogout}>
          <i className="ti ti-logout me-2" /> {t('logout')}
        </Link>
      </div>
    </div>
  );
};

export default UserDropdown;
